import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toThunkRejectValue } from "../../../Common/isRequestCanceled";
import {
  BASE_URL,
  QUICKVEE_CUSTOM_DELETE,
  QUICKVEE_CUSTOM_LIST,
} from "../../../Constants/Config";

const initialState = {
  loading: false,
  quickveeCustomList: [],
  successMessage: "",
  error: "",
};

export const fetchQuickveeCustomList = createAsyncThunk(
  "QuickveeCustom/fetchQuickveeCustomList",
  async (data, { rejectWithValue }) => {
    // console.log("data",data)
    const { token, ...dataNew } = data;

    try {
      const response = await axios.post(
        BASE_URL + QUICKVEE_CUSTOM_LIST,
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("fetchQuickveeCustomList response",response)
      if (response.data?.status === true) {
        // console.log("response.statusText ===  && response.status === 200")
        return response?.data?.qc_data;
      } else {
        console.error("Unexpected response", response);
        return rejectWithValue(response.data || "Unexpected error");
      }
    } catch (error) {
      console.log("error from fetchQuickveeCustomList", error);
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

export const deleteQuickveeCustomData = createAsyncThunk(
  "QuickveeCustom/deleteQuickveeCustomData",
  async (data, { rejectWithValue }) => {
    const { token, ...dataNew } = data;
    try {
      const response = await axios.post(
        BASE_URL + QUICKVEE_CUSTOM_DELETE,
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`, // Use data?.token directly
          },
        }
      );
      if (response) {
        // console.log(response);
        return {
          qc_id: data.id,
        };
      }
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

const quickveeCustomSlice = createSlice({
  name: "QuickveeCustom",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchQuickveeCustomList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchQuickveeCustomList.fulfilled, (state, action) => {
      state.loading = false;
      state.quickveeCustomList = action.payload;
      state.error = "";
    });
    builder.addCase(fetchQuickveeCustomList.rejected, (state, action) => {
      state.loading = false;
      state.quickveeCustomList = [];
      state.error = action?.error?.message || "Unable to fetch data";
    });
    builder.addCase(deleteQuickveeCustomData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteQuickveeCustomData.fulfilled, (state, action) => {
      // console.log("deleteQuickveeCustomData.fulfilled", action)
      state.loading = false;
      state.successMessage = action.payload.message;
      state.quickveeCustomList = state.quickveeCustomList.filter(
        (item) => item && item.id !== action.payload.qc_id
      );

      state.error = ""; // Reset the error message
    });
    builder.addCase(deleteQuickveeCustomData.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
  },
});

export default quickveeCustomSlice.reducer;
